import api from '../api/apicheckout'

export const checkout = {
    state: {
		pagamentos:[],
		produto:undefined,
		localizado: false,
		link: '',
	},
	reducers: {
		buscarProduto: (state, payload) => {
			console.log('buscarProduto: payload', payload)
            return {
                ...state,
                produto: payload
			}
		},
		definirListaPagamentos: (state, payload) => {
			console.log('definirListaPagamentos: payload', payload)
            return {
                ...state,
                pagamentos: payload
			}
		},
		statusLocalizado: (state, payload) => {
            return {
                ...state,
                localizado: payload.data || payload
            }
		},
		linkGerado: (state, payload) => {
			console.log('linkGerado: payload', payload)

            return {
                ...state,
                link: payload
            }
        },
	},
	effects: (dispatch) => ({
		async asyncBuscarProduto(payload) {
			await api.get(`Pagamentos/BuscarProduto/${payload.codigo}`,{headers:{Authorization:`Bearer ${payload.token}`}})
			.then(function(response) {

					if(response.status == "204" ){
						console.log('Nao localizado')
						dispatch.checkout.statusLocalizado(false);
					}else{
						console.log(':::: asyncBuscarProduto SUCESSO::::', response)

					dispatch.checkout.buscarProduto(JSON.parse(response.data));
					dispatch.checkout.statusLocalizado(true);
					console.log('State:', checkout.produto)

					}
			}).catch(function(error) {
				console.log(error)
			});
		},
		async asyncGerarLink(payload) {
			await api.post("/Pagamentos/Cadastrar", payload.documents, {
				headers: {
					Authorization: `Bearer ${payload.token}`
				}
			}).then(function(response) {
			  console.log('Cadastrado', response)
			  var linkGerado = response.data.link
			  dispatch.checkout.linkGerado(linkGerado);
			}).catch(function(error) {
				console.log(error)
			});
		},
		async asyncBuscarRequisicao(payload) {
			await api.post("/Pagamentos", payload.dados, {
				headers: {
					Authorization: `Bearer ${payload.token}`
				}
			}).then(function (response) {
					console.log('Pagamentos:', JSON.parse(response.data));
					dispatch.checkout.definirListaPagamentos(JSON.parse(response.data));
			}).catch(function (error) {
					console.log('Pagamentos error:', error)
			})
		},
		async asyncBuscarPagamentos(payload) {
			await api.post("/Pagamentos", payload.dados, {
				headers: {
					Authorization: `Bearer ${payload.token}`
				}
			}).then(function (response) {
					console.log('Pagamentos:', JSON.parse(response.data));
					dispatch.checkout.definirListaPagamentos(JSON.parse(response.data));
			}).catch(function (error) {
					console.log('Pagamentos error:', error)
			})
		},
	}),
}
